{
  "applications": {
    "actions": {
      "journal": "Journal",
      "notification_filters": "Notification filters",
      "refresh_applications": "Refresh applications",
      "restart": "Restart",
      "shutdown": "Shutdown",
      "switch_to_grouping_by_application": "Aggregate same instances as application",
      "switch_to_grouping_by_group": "Group same instance by same group name",
      "unregister": "Unregister"
    },
    "last_update": "Last update",
    "all_up": "all up",
    "all_down": "all down",
    "all_unknown": "all in unknown state",
    "some_unknown": "some instances are in unknown state",
    "some_down": "some instances are down",
    "applications": "Applications",
    "fetching_notification_filters_failed": "Fetching notification filters failed.",
    "notification_filter": {
      "none": "No notification filters set.",
      "removed": "Notification filter removed."
    },
    "instances": "Instances",
    "loading_applications": "Loading applications...",
    "no_applications_registered": "No applications registered.",
    "notifications_suppressed_for": "Notifications on <code>{name}</code> are suppressed for",
    "restricted": "restricted",
    "server_connection_failed": "Server connection failed.",
    "suppress_notifications_on": "Suppress notifications on <code>{name}</code> for",
    "status": "Status",
    "label": "Applications",
    "up": "up",
    "down": "down",
    "offline": "offline",
    "shutdown": "Shutdown application <code>{name}</code>?",
    "shutdown_successful": "Successfully shutdown application {name}.",
    "refreshed": "Applications refreshed.",
    "restart": "Restart application <code>{name}</code>?",
    "restarted": "Successfully restarted application <code>{name}</code>.",
    "unregister": "Deregister application <code>{name}</code>?",
    "unregister_successful": "Successfully deregistered application <code>{name}</code>.",
    "unregister_failed": "Deregistration of application <code>{name}</code> failed ({error})."
  },
  "instances": {
    "shutdown": "Shutdown instance <code>{name}</code>?",
    "shutdown_successful": "Successfully shutdown instances {name}.",
    "shutdown_failed": "Failed to shutdown instances {name}.",
    "open_details": "Open instance details",
    "restart": "Restart instance <code>{name}</code>?",
    "restarted": "Successfully restarted instance {name}.",
    "unregister": "Deregister instance <code>{name}</code>?",
    "unregister_successful": "Successfully deregistered instance <code>{name}</code>.",
    "unregister_failed": "Deregistration of instance <code>{name}</code> failed ({error})."
  },
  "notification_filter_center": {
    "description": "Notifications on following applications or instances will be suppressed."
  },
  "filter": {
    "no_results": "No results matching your filter."
  }
}
